/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckMultipaxSession } from './PaxCheckMultipaxSession';
import {
    PaxCheckMultipaxSessionFromJSON,
    PaxCheckMultipaxSessionFromJSONTyped,
    PaxCheckMultipaxSessionToJSON,
    PaxCheckMultipaxSessionToJSONTyped,
} from './PaxCheckMultipaxSession';

/**
 * Response for /start endpoint
 * @export
 * @interface PaxCheckStart1ResponseData
 */
export interface PaxCheckStart1ResponseData {
    /**
     * MultiPax session id
     * @type {string}
     * @memberof PaxCheckStart1ResponseData
     */
    sessionId: string;
    /**
     * Session token to authenticate to other API endpoints
     * @type {string}
     * @memberof PaxCheckStart1ResponseData
     */
    paxCheckToken: string;
    /**
     * 
     * @type {PaxCheckMultipaxSession}
     * @memberof PaxCheckStart1ResponseData
     */
    session?: PaxCheckMultipaxSession;
}

/**
 * Check if a given object implements the PaxCheckStart1ResponseData interface.
 */
export function instanceOfPaxCheckStart1ResponseData(value: object): value is PaxCheckStart1ResponseData {
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    if (!('paxCheckToken' in value) || value['paxCheckToken'] === undefined) return false;
    return true;
}

export function PaxCheckStart1ResponseDataFromJSON(json: any): PaxCheckStart1ResponseData {
    return PaxCheckStart1ResponseDataFromJSONTyped(json, false);
}

export function PaxCheckStart1ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckStart1ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['session_id'],
        'paxCheckToken': json['pax_check_token'],
        'session': json['session'] == null ? undefined : PaxCheckMultipaxSessionFromJSON(json['session']),
    };
}

export function PaxCheckStart1ResponseDataToJSON(json: any): PaxCheckStart1ResponseData {
    return PaxCheckStart1ResponseDataToJSONTyped(json, false);
}

export function PaxCheckStart1ResponseDataToJSONTyped(value?: PaxCheckStart1ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'session_id': value['sessionId'],
        'pax_check_token': value['paxCheckToken'],
        'session': PaxCheckMultipaxSessionToJSON(value['session']),
    };
}

